var _defs, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeedometerLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 251.2 147.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-3);}.cls-3{fill:url(#linear-gradient-4);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-5);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 8.67,
    y1: 69.14,
    x2: 178.66,
    y2: 69.14,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa923c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbcd15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 200.53,
    y1: 130,
    x2: 244.53,
    y2: 130,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed4899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fa923c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 201.53,
    y1: 61,
    x2: 221.53,
    y2: 61,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bfdbfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dcebfe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 108.88,
    y1: 130.34,
    x2: 203.71,
    y2: 35.51,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#38bdf8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34d399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 213.53,
    y1: 91,
    x2: 236.53,
    y2: 91,
    xlinkHref: "#linear-gradient-3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.3,21.07c2.1-1.39,1.71-4.57-.65-5.43-13.44-4.94-27.96-7.63-43.11-7.63C66.49,8,11.78,60.77,8.67,127.04c-.12,2.52,2.65,4.11,4.75,2.72L177.3,21.07Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M239.53,135h-34c-2.76,0-5-2.24-5-5s2.24-5,5-5h34c2.76,0,5,2.24,5,5s-2.24,5-5,5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.53,69c-1.29,0-2.56-.63-3.33-1.78-1.23-1.84-.73-4.32,1.11-5.55l12-8c1.84-1.23,4.32-.73,5.55,1.11,1.23,1.84,.73,4.32-1.11,5.55l-12,8c-.68,.45-1.45,.67-2.21,.67Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M116.95,138.28h0c-3.57-2.64-4.35-7.66-1.76-11.26L189.16,24.29c1.76-2.1,4.98,.34,3.44,2.61l-63.83,108.96c-2.44,4.16-7.94,5.29-11.82,2.42Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M217.53,97c-1.77,0-3.39-1.18-3.86-2.97-.57-2.13,.7-4.33,2.83-4.9l15-4c2.14-.57,4.33,.7,4.9,2.83,.57,2.13-.7,4.33-2.83,4.9l-15,4c-.35,.09-.69,.14-1.03,.14Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedometerLogo);
export default __webpack_public_path__ + "static/media/speedometer-logo.a0bb2d8af11a5b1f7a6f1b14e1ae35d0.svg";
export { ForwardRef as ReactComponent };